export default __webpack_public_path__ + "static/media/Show-documentation.2fab4454.md";